import { get, post } from 'services/request';
import { Card, CardsPage, ComponentRow, PopulateReport, ScanResult, Stats } from './types';

const isEmpty = (o: object) => Object.keys(o).length === 0;

export const fetchCards = async (text: string, limit = 10000) => {
  const r = await get<CardsPage>('/hanzi/cards', { search: text, page: 1, limit });
  return isEmpty(r) ? null : r;
};

/** `id` is a character, gf-<n>, or the numeric id of the grids. */
export const fetchCard = async (id: string | number) => {
  const r = await get<Card>('/hanzi/card', { id });
  return isEmpty(r) ? null : r;
};

export const fetchComponents = async () => {
  const r = await get<{ rows: ComponentRow[] }>('/hanzi/components');
  return isEmpty(r) ? null : r.rows;
};

export const fetchStats = async () => {
  const r = await get<Stats>('/hanzi/stats');
  return isEmpty(r) ? null : r;
};

export const wizardScan = async () => {
  const r = await get<ScanResult>('/hanzi/wizard/scan');
  return isEmpty(r) ? null : r;
};

export const wizardApply = async (chars: string[], apply: boolean) => {
  const r = await post<{ result: string; report: PopulateReport }>('/hanzi/wizard/apply', { chars, apply });
  return r.ok && r.data ? r.data.report : null;
};

export const rebuildCard = async (id: string) => {
  const r = await post<{ result: string; report: PopulateReport; card: Card }>('/hanzi/card/rebuild', { id });
  return r.ok && r.data ? r.data.card : null;
};
